"use strict";

exports.__esModule = true;
exports.default = void 0;
var _tagTester = _interopRequireDefault(require("./_tagTester.js"));
var _has = _interopRequireDefault(require("./_has.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var isArguments = (0, _tagTester.default)('Arguments');

// Define a fallback version of the method in browsers (ahem, IE < 9), where
// there isn't any inspectable "Arguments" type.
(function () {
  if (!isArguments(arguments)) {
    isArguments = function isArguments(obj) {
      return (0, _has.default)(obj, 'callee');
    };
  }
})();
var _default = exports.default = isArguments;